import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/avatar.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { AVATAR_SIZES } from './types.js';
import { Icon } from '../../node_modules/@flixbus/honeycomb-icons-react/dist/esm/components/icon/icon.js';
import { IconProfile } from '../../node_modules/@flixbus/honeycomb-icons-react/dist/esm/components/icons/inline/icon-profile.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem.init('avatar', styles);
var Avatar = function (_a) {
  var alt = _a.alt,
    _b = _a.as,
    as = _b === void 0 ? 'div' : _b,
    children = _a.children,
    extraClasses = _a.extraClasses,
    size = _a.size,
    src = _a.src,
    url = _a.url,
    rest = __rest(_a, ["alt", "as", "children", "extraClasses", "size", "src", "url"]);
  var avatarClassNames = bem.b([size], extraClasses);
  // if no url passed render as div (default element type) or custom element provided via "as"
  var WrapperElement = url ? 'a' : as;
  // do not set "href" if no url is given, prevents setting href on a div
  var wrapperProps = __assign({}, url ? __assign({
    className: avatarClassNames,
    href: url
  }, rest) : __assign({
    className: avatarClassNames
  }, rest));
  return /*#__PURE__*/React__default__default.createElement(WrapperElement, __assign({}, wrapperProps), src && /*#__PURE__*/React__default__default.createElement("img", {
    className: bem.e('image'),
    src: src,
    alt: alt
  }), !src && children);
};
Avatar.displayName = 'Avatar';
Avatar.defaultProps = {
  alt: '',
  as: 'div',
  extraClasses: '',
  children: /*#__PURE__*/React__default__default.createElement(Icon, {
    InlineIcon: IconProfile,
    size: "cover"
  }),
  size: null,
  src: null,
  url: null
};
Avatar.propTypes = {
  alt: function (_a) {
    var alt = _a.alt,
      src = _a.src;
    if (src !== null && alt === '') {
      return new Error('The "alt" text is required if a source is provided to Avatar.');
    }
    if (typeof alt !== 'string') {
      return new Error("Avatar \"alt\" accepts only plain strings. Received \"".concat(typeof alt, "\" instead."));
    }
    return null;
  },
  as: PropTypes__default.elementType,
  extraClasses: PropTypes__default.string,
  children: PropTypes__default.node,
  size: PropTypes__default.oneOf(AVATAR_SIZES),
  src: PropTypes__default.string,
  url: PropTypes__default.string
};
var Avatar$1 = Injecss(Avatar, styles);

export { Avatar, Avatar$1 as default };
